var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { memoize } from '../../../../utils/mobx/decorators/memoize';
export class BrowserConfig {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get browserRuntime() {
        return this.parent;
    }
    get isMicrophoneActivatedByUser() {
        const mic = this.browserRuntime.app.appCookies.reactiveCookies.get('mic');
        return mic === '1';
    }
    set isMicrophoneActivatedByUser(b) {
        this.browserRuntime.app.appCookies.reactiveCookies.set('mic', b ? '1' : '0');
    }
    get canPlayVp9() {
        const video = document.createElement('video');
        return ['probably', 'maybe'].includes(video.canPlayType('video/webm; codecs="vp9"'));
    }
}
__decorate([
    memoize
], BrowserConfig.prototype, "canPlayVp9", null);
